module.exports = __webpack_public_path__ + "static/img/B摄像头.db904d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/拖拉机/B摄像头.png
// module id = 5/Ju
// module chunks = 0